import { createListenerMiddleware } from '@reduxjs/toolkit';

import { clearTokenStorage, getToken, setTokens } from '@/lib';
import type { Org, OrgRoleType, User } from '@/lib/api';
import * as api from '@/lib/api';
import { logger } from '@/lib/hooks/useLogger';

import { actions } from './reducer';

const loginMiddleware = createListenerMiddleware();
loginMiddleware.startListening({
    actionCreator: actions.login,
    effect: async ({ payload: { accessToken, refreshToken } }, { dispatch }) => {
        setTokens({ accessToken, refreshToken });
        const { org, role, user } = await api.getCurrentUser();
        dispatch(actions.authComplete({ user, role: role ?? undefined, org: org ?? undefined }));
    },
});

const logoutMiddleware = createListenerMiddleware();
logoutMiddleware.startListening({
    actionCreator: actions.logout,
    effect: () => clearTokenStorage(),
});

const authInitMiddleware = createListenerMiddleware();
authInitMiddleware.startListening({
    actionCreator: actions.init,
    effect: async (_payload, { dispatch }) => {
        let token = await getToken();
        if (!token) {
            try {
                const result = await api.checkAuth();
                if (result.token) {
                    const { access_token: accessToken, refresh_token: refreshToken } = result.token;
                    token = accessToken;
                    setTokens({ accessToken, refreshToken });
                } else {
                    dispatch(actions.preauth());
                    return;
                }
            } catch {
                dispatch(actions.preauth());
                return;
            }
        }
        let result = false;
        let user: User | undefined;
        let role: OrgRoleType | undefined | null;
        let org: Org | undefined | null;
        try {
            [result, { org, role, user }] = await Promise.all([api.checkToken(), api.getCurrentUser()]);
            logger.log.info({ userId: user?.id, orgId: org?.id, role }, 'Auth init success');
        } finally {
            if (result && user) {
                dispatch(actions.authenticated({ token }));
                dispatch(actions.authComplete({ user, role: role ?? undefined, org: org ?? undefined }));
            } else {
                dispatch(actions.preauth());
            }
        }
    },
});
export const authMiddleware = [loginMiddleware.middleware, authInitMiddleware.middleware, logoutMiddleware.middleware];
